document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const stickyBar = document.querySelector('[data-mobile-sticky]');
  const primaryProductForm = document.querySelector('[data-product-form]');
  const primarySubmit = primaryProductForm?.querySelector('[type="submit"]');

  const setScrolled = () => header?.classList.toggle('is-scrolled', window.scrollY > 16);
  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = body.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      mobileMenu.hidden = !isOpen;
    });
  }

  const galleryItems = document.querySelectorAll('[data-gallery-media]');
  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const targetId = thumb.getAttribute('data-target');
      const target = document.getElementById(targetId);
      if (!target) return;

      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      galleryItems.forEach((item) => {
        item.classList.remove('is-active');
        item.querySelector('video')?.pause();
      });
      thumb.classList.add('is-active');
      target.classList.add('is-active');
      if (window.matchMedia('(max-width: 560px)').matches) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  });

  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const price = option.getAttribute('data-price');
      const compare = option.getAttribute('data-compare-price');
      const available = option.getAttribute('data-available') === 'true';
      const priceEl = document.querySelector('[data-product-price]');
      const compareEl = document.querySelector('[data-product-compare]');
      const stockEl = document.querySelector('[data-stock-message]');

      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }
      if (primarySubmit) {
        primarySubmit.disabled = !available;
        primarySubmit.querySelector('span').textContent = available
          ? primarySubmit.getAttribute('data-add-label')
          : primarySubmit.getAttribute('data-sold-label');
      }
      if (stockEl) {
        const inventory = Number(option.getAttribute('data-inventory') || 0);
        const showStock = option.getAttribute('data-inventory-managed') === 'true' && inventory > 0 && inventory <= 5;
        stockEl.hidden = !showStock;
        stockEl.textContent = showStock ? `Sınırlı stok: ${inventory} adet kaldı.` : '';
      }

      const whatsappBtn = document.querySelector('[data-product-whatsapp]');
      if (whatsappBtn && option) {
        const phone = whatsappBtn.getAttribute('data-phone');
        const baseTitle = whatsappBtn.getAttribute('data-base-title');
        const baseUrl = whatsappBtn.getAttribute('data-base-url');
        const variantTitle = option.textContent.trim().split('-')[0].trim();
        const text = `Merhaba Ruzinta, ${baseTitle} (${variantTitle}) siparişi vermek istiyorum. Yardımcı olabilir misiniz? ${baseUrl}`;
        whatsappBtn.setAttribute('href', `https://wa.me/${phone}?text=${encodeURIComponent(text)}`);
      }
    });
  }

  if (stickyBar && primarySubmit) {
    stickyBar.hidden = false;
    const observer = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -100px' }
    );
    observer.observe(primarySubmit);

    stickyBar.querySelector('[data-sticky-submit]')?.addEventListener('click', () => primarySubmit.click());
  }

  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const step = button.getAttribute('data-quantity-button') === 'plus' ? 1 : -1;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchInput = searchDrawer?.querySelector('[data-predictive-search-input]');
  const searchForm = searchDrawer?.querySelector('[data-predictive-search-form]');
  const searchResults = searchDrawer?.querySelector('[data-predictive-search-results]');
  let searchTimer;
  let searchController;
  let searchTrigger;

  const setSearchDrawer = (open, trigger) => {
    if (!searchDrawer) return;
    const wasOpen = !searchDrawer.hidden;
    if (open) searchTrigger = trigger || document.activeElement;
    searchDrawer.hidden = !open;
    searchDrawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('search-open', open);
    if (open) window.setTimeout(() => searchInput?.focus(), 40);
    if (!open && wasOpen) searchTrigger?.focus();
  };

  document.querySelectorAll('[data-search-open]').forEach((button) => {
    button.addEventListener('click', () => setSearchDrawer(true, button));
  });

  searchDrawer?.querySelectorAll('[data-search-close]').forEach((button) => {
    button.addEventListener('click', () => setSearchDrawer(false));
  });

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const term = searchInput.value.trim();
    if (!term) {
      searchResults.innerHTML = '<p class="search-drawer__hint">Cüzdan, kartlık veya model adını yaz.</p>';
      return;
    }

    searchTimer = window.setTimeout(async () => {
      searchController?.abort();
      searchController = new AbortController();
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection',
        'resources[limit]': '6',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(`${searchForm.dataset.searchUrl}?${params}`, { signal: searchController.signal });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const html = await response.text();
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-predictive-search');
        searchResults.innerHTML = section?.innerHTML || '<p class="search-drawer__hint">Sonuç bulunamadı.</p>';
      } catch (error) {
        if (error.name !== 'AbortError') {
          searchResults.innerHTML = '<p class="search-drawer__hint">Arama şu anda yüklenemedi. Enter tuşuyla aramayı tamamlayabilirsin.</p>';
        }
      }
    }, 220);
  });

  const quickView = document.querySelector('[data-quick-view-modal]');
  let quickViewTrigger;
  const setQuickView = (open, trigger) => {
    if (!quickView) return;
    const wasOpen = !quickView.hidden;
    if (open) quickViewTrigger = trigger || document.activeElement;
    quickView.hidden = !open;
    quickView.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('quick-view-open', open);
    if (open) quickView.querySelector('[data-quick-view-close]')?.focus();
    if (!open && wasOpen) quickViewTrigger?.focus();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quick-view-open]');
    if (!button) return;
      const image = quickView?.querySelector('[data-quick-view-image]');
      const compare = quickView?.querySelector('[data-quick-view-compare]');
      const add = quickView?.querySelector('[data-quick-view-add]');
      const available = button.dataset.productAvailable === 'true';

      if (image) {
        image.src = button.dataset.productImage || '';
        image.alt = button.dataset.productTitle || '';
      }
      if (compare) {
        compare.textContent = button.dataset.productCompare || '';
        compare.hidden = !button.dataset.productCompare;
      }
      if (add) {
        add.disabled = !available;
        add.textContent = available ? 'Sepete ekle' : 'Tükendi';
      }

      quickView.querySelector('[data-quick-view-title]').textContent = button.dataset.productTitle || '';
      quickView.querySelector('[data-quick-view-type]').textContent = button.dataset.productType || 'Hakiki deri';
      quickView.querySelector('[data-quick-view-price]').textContent = button.dataset.productPrice || '';
      quickView.querySelector('[data-quick-view-variant]').value = button.dataset.productVariant || '';
      quickView.querySelector('[data-quick-view-link]').href = button.dataset.productUrl || '#';
      setQuickView(true, button);
  });

  quickView?.querySelectorAll('[data-quick-view-close]').forEach((button) => {
    button.addEventListener('click', () => setQuickView(false));
  });

  const galleryLightbox = document.querySelector('[data-gallery-lightbox]');
  const galleryLightboxImage = galleryLightbox?.querySelector('[data-gallery-lightbox-image]');
  const galleryZoomLabel = galleryLightbox?.querySelector('[data-gallery-zoom-label]');
  let galleryTrigger;
  let galleryScale = 1;

  const updateGalleryZoom = () => {
    if (!galleryLightboxImage) return;
    galleryLightboxImage.style.transform = `scale(${galleryScale})`;
    if (galleryZoomLabel) galleryZoomLabel.textContent = `${Math.round(galleryScale * 100)}%`;
  };

  const setGalleryLightbox = (open, trigger) => {
    if (!galleryLightbox) return;
    const wasOpen = !galleryLightbox.hidden;
    if (open) galleryTrigger = trigger || document.activeElement;
    galleryLightbox.hidden = !open;
    galleryLightbox.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('lightbox-open', open);
    if (open) {
      galleryScale = 1;
      updateGalleryZoom();
      galleryLightbox.querySelector('[data-gallery-close]')?.focus();
    } else if (wasOpen) {
      galleryTrigger?.focus();
    }
  };

  document.querySelectorAll('[data-gallery-expand]').forEach((button) => {
    button.addEventListener('click', () => {
      if (galleryLightboxImage) {
        galleryLightboxImage.src = button.dataset.gallerySrc || '';
        galleryLightboxImage.alt = button.dataset.galleryAlt || '';
      }
      setGalleryLightbox(true, button);
    });
  });

  galleryLightbox?.querySelectorAll('[data-gallery-close]').forEach((button) => {
    button.addEventListener('click', () => setGalleryLightbox(false));
  });

  galleryLightbox?.querySelectorAll('[data-gallery-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      galleryScale = button.dataset.galleryZoom === 'in'
        ? Math.min(3, galleryScale + 0.25)
        : Math.max(1, galleryScale - 0.25);
      updateGalleryZoom();
    });
  });

  const legalNotice = document.querySelector('[data-legal-notice]');
  let legalTrigger;
  const setLegalNotice = (open, trigger) => {
    if (!legalNotice) return;
    const wasOpen = !legalNotice.hidden;
    if (open) legalTrigger = trigger || document.activeElement;
    legalNotice.hidden = !open;
    legalNotice.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('legal-notice-open', open);
    if (open) legalNotice.querySelector('[data-legal-close]')?.focus();
    if (!open && wasOpen) legalTrigger?.focus();
  };

  document.querySelectorAll('[data-legal-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setLegalNotice(true, button);
    });
  });

  legalNotice?.querySelectorAll('[data-legal-close]').forEach((button) => {
    button.addEventListener('click', () => setLegalNotice(false));
  });

  const getOpenDialog = () => (
    document.querySelector('[data-gallery-lightbox]:not([hidden]) [role="dialog"]')
    || document.querySelector('[data-quick-view-modal]:not([hidden]) [role="dialog"]')
    || document.querySelector('[data-search-drawer]:not([hidden]) [role="dialog"]')
    || document.querySelector('[data-legal-notice]:not([hidden]) [role="dialog"]')
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setGalleryLightbox(false);
      setQuickView(false);
      setSearchDrawer(false);
      setLegalNotice(false);
      return;
    }
    if (event.key !== 'Tab') return;

    const dialog = getOpenDialog();
    if (!dialog) return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-facet-input]').forEach((input) => {
    input.addEventListener('change', () => input.form?.submit());
  });

  document.querySelectorAll('[data-facets-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector('[data-facets-panel]')?.classList.toggle('is-open');
    });
  });

  const giftToggle = document.querySelector('[data-gift-toggle]');
  const giftMessage = document.querySelector('[data-gift-message]');
  giftToggle?.addEventListener('change', () => {
    if (giftMessage) giftMessage.hidden = !giftToggle.checked;
  });

  document.querySelectorAll('[data-finder-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      const finder = button.closest('[data-model-finder]');
      const result = finder?.querySelector('[data-finder-result]');
      if (!result) return;

      finder.querySelectorAll('[data-finder-choice]').forEach((choice) => choice.classList.remove('is-selected'));
      button.classList.add('is-selected');
      result.querySelector('[data-finder-title]').textContent = button.dataset.title || '';
      result.querySelector('[data-finder-text]').textContent = button.dataset.text || '';
      const link = result.querySelector('[data-finder-link]');
      link.href = button.dataset.link || '/collections/all';
      link.textContent = button.dataset.linkLabel || 'Modelleri gör';
      result.hidden = false;
    });
  });

  const revealItems = document.querySelectorAll('[data-reveal], .section-heading, .product-card');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -48px' });

    revealItems.forEach((item) => {
      item.classList.add('reveal');
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
});

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const recommendation = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
          if (recommendation?.innerHTML.trim()) this.innerHTML = recommendation.innerHTML;
        })
        .catch(() => {});
    }
  });
}
